import React, { useEffect, useState } from "react";
import { GoogleMap, MarkerClusterer, MarkerF, OverlayView, OverlayViewF, useJsApiLoader } from "@react-google-maps/api";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { base, calculateDistance } from "../../constants/base";
import { useMemo } from "react";

const containerStyle = {
    width: "100%",
    height: "400px",
    borderRadius: "20px",
    border: 'none !important',
    outline: 'none !important',
};

const GoogleMapShow = () => {

    const user = useSelector((state) => state?.AuthSlice?.user);
    const userProfilePicture = user?.images?.[0]?.path;
    const allResults = useSelector((state) => state?.SearchFilterSlice?.results);
    const [allResultsAddress, setAllResultsAddress] = useState([]);
    const [tooltipVisibleSingle, setTooltipVisibleSingle] = useState(false);
    const getAllResultsAddress = () => {
        const addresses = allResults?.map((singleAddress) => ({
            lat: parseFloat(singleAddress?.address?.latitude),
            lng: parseFloat(singleAddress?.address?.longitude),
            image: singleAddress?.images[0]?.path,
            id: singleAddress?.id,
            name: singleAddress?.name
        }));
        setAllResultsAddress(addresses);
    };

    useEffect(() => {
        getAllResultsAddress();
    }, [allResults]);

    const [longitude, setLongitude] = useState(null);
    const [latitude, setLatitude] = useState(null);
    const [map, setMap] = useState(null);

    const loaderOptions = useMemo(() => ({
        id: "google-map-script",
        googleMapsApiKey: process.env.REACT_APP_GOOGLEMAPS_API_KEY,
        libraries: ["places"],
    }), []);

    const { isLoaded } = useJsApiLoader(loaderOptions);

    useEffect(() => {
        const requestLocation = () => {
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        setLatitude(position.coords.latitude);
                        setLongitude(position.coords.longitude);
                    },
                    (error) => {
                        console.error("Error getting location:", error);
                        switch (error.code) {
                            case error.PERMISSION_DENIED:
                                break;
                            case error.POSITION_UNAVAILABLE:
                                break;
                            case error.TIMEOUT:
                                break;
                            default:
                                break;
                        }
                    }
                );
            } else {
                console.log("Geolocation is not supported by your browser.");
            }
        };

        const checkPermission = async () => {
            if (navigator.permissions) {
                try {
                    const permissionStatus = await navigator.permissions.query({ name: "geolocation" });
                    if (permissionStatus.state === "granted") {
                        requestLocation();
                    } else if (permissionStatus.state === "prompt") {
                        requestLocation();
                    } else if (permissionStatus.state === "denied") {
                        console.log("Location access is blocked. Please enable location services in your browser settings and refresh the page.");
                    }
                } catch (err) {
                    console.error("Error checking permissions:", err);
                    requestLocation();
                }
            } else {
                requestLocation();
            }
        };

        checkPermission();
    }, []);


    const center = {
        lat: latitude || 0,
        lng: longitude || 0,
    };


    const onLoad = (map) => {
        map.setCenter(center);
        map.setZoom(10);
        setMap(map);
    };

    const onUnmount = () => {
        setMap(null);
    };

    useEffect(() => {
        if (longitude && latitude) {
            map?.setCenter(center);
        }
    }, [center]);

    return isLoaded ? (
        <GoogleMap
            key={allResultsAddress?.length}
            mapContainerStyle={containerStyle}
            zoom={10}
            onLoad={onLoad}
            onUnmount={onUnmount}
        // onCenterChanged={onLoad}
        >
            {/* Main User Marker */}
            {
                user !== "" ? <OverlayViewF position={center} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
                    <div
                        style={{
                            position: "relative",
                            backgroundColor: "#fff",
                            borderRadius: "100px",
                            padding: "5px",
                            width: "50px",
                            height: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer !important"
                        }}

                        onMouseEnter={() => setTooltipVisibleSingle(true)}
                        onMouseLeave={() => setTooltipVisibleSingle(false)}
                    >
                        {userProfilePicture ? <img
                            src={`${base.imageUrl}${userProfilePicture}`}
                            alt="Profile"
                            style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: 'cover', cursor: 'pointer' }}
                        /> : <img
                            src="/images/user-demo.jpg"
                            alt="Profile"
                            style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: 'cover', cursor: 'pointer' }}
                        />}

                        {tooltipVisibleSingle && (
                            <div className="map-tooltip" style={{ bottom: '60px' }}>
                                <p>{user?.name || "User Name"} (You)</p>
                            </div>
                        )}
                    </div>
                </OverlayViewF> : ""
            }


            {/* <MarkerF
                position={center}
                icon={{
                    url: `${base.imageUrl}${userProfilePicture}`,
                    scaledSize: new window.google.maps.Size(50, 50),
                }}
            /> */}

            {/* Worker Markers */}
            <MarkerClusterer>
                {(clusterer) =>
                    allResultsAddress?.map((item, index) => (
                        <OverlayViewF
                            key={index}
                            position={{ lat: item.lat, lng: item.lng }}
                            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                            style={{
                                zIndex: '15',
                                position: 'relative',
                                border: '2px solid green',
                                backgroundColor: 'red',
                                cursor: 'pointer !imoportant',
                                position: 'relative !important',
                            }}
                        >
                            <Link to={`/service/provider/${item?.id}`} style={{ textDecoration: 'none', cursor: 'pointer !important', }}>
                                <div
                                    style={{
                                        backgroundColor: "trasnparent",
                                        // padding: "10px",
                                        cursor: 'pointer !imoportant',
                                        zIndex: 10,
                                    }}
                                    className="cursor-pointer tooltip-box-hover"
                                >
                                    <img
                                        src={`${base.imageUrl}${item?.image}`}
                                        alt="Worker Profile"
                                        style={{
                                            position: 'relative',
                                            width: "50px",
                                            height: "50px",
                                            borderRadius: "100px",
                                            objectFit: 'cover',
                                            cursor: "pointer",
                                            zIndex: '15 !important',
                                            border: '5px solid #ffffff'
                                        }}
                                        className="cursor-pointer"
                                    />

                                    <div className="map-tooltip map-marker-professionals" style={{ backgroundImage: `url(${base.imageUrl}${item?.image})` }}>
                                        <p className="mb-1">{item?.name || "User Name"}</p>
                                        {longitude &&
                                            latitude &&
                                            item?.lat &&
                                            item?.lng && (
                                                <p className="card-common-text">
                                                    {calculateDistance(latitude, longitude, item?.lat, item?.lng)} km away
                                                </p>
                                            )}
                                    </div>
                                </div>
                            </Link>
                        </OverlayViewF>
                    ))}
            </MarkerClusterer>
        </GoogleMap>
    ) : (
        <div>Loading...</div>
    );
};

export default GoogleMapShow;